import React from "react";
import { Avatar } from "@mui/material";

import { Row } from "react-bootstrap";

import { imageUrl } from "../../config";

import CastTeam from "../molecules/CastTeam";
import { CastAnswer } from "../organisms/AnswerChallengeQuestions";

interface QuestionAnswerProps {
    answer: CastAnswer;
}

const QuestionAnswer: React.FC<QuestionAnswerProps> = ({ answer }) => {
    return (
        <div
            style={{
                fontSize: 15,
                fontWeight: "normal",
            }}
        >
            <Row noGutters className="align-items-center mt-1">
                {answer ? (
                    <>
                        <Avatar
                            style={{
                                height: 50,
                                width: 50,
                            }}
                            src={`${imageUrl}${answer.pic}`}
                        />
                        <div className="pl-2">
                            <span>{`${answer.first_name && answer.first_name} ${
                                answer.last_name && answer.last_name
                            }`}</span>
                            <CastTeam
                                left
                                size={10}
                                team={
                                    answer.cast ? answer.cast.team : answer.team
                                }
                                partner={
                                    answer.cast
                                        ? answer.cast.partner
                                        : answer.partner
                                }
                            />
                        </div>
                    </>
                ) : (
                    <div>No answer selected</div>
                )}
            </Row>
        </div>
    );
};

export default QuestionAnswer;
